export const MenuMock = {
    mode:"horizontal" ,
    defaultSelectedKeys:['Garantizados'],
    items:[{
        nombre: "Comprar",
        Key: "Comprar",
        icon: null,
        url:"/comprar",
        spaName:"derco-mf-comprar"
    },
    {
        nombre: "Vender",
        Key: "Vender",
        icon: null,
        url:"/ventas",
        spaName:"derco-mf-vender"

    },
    {
        nombre: "Financiamiento",
        Key: "Financiamiento",
        icon: null,
        url:"/financiamiento",
        spaName:"derco-mf-financiar"

    },
    {
        nombre: "Vende Dueño",
        Key: "vendeDueno",
        icon: null,
        url:"/vende-dueno",
        spaName:"derco-mf-sucursales"
    },
    {
        nombre: "Publica tu auto",
        Key: "publicaTuAuto",
        icon: null,
        url:"/sesion/registro/vender",
        spaName:"derco-mf-publica-auto"
    },
    
    {
        nombre: "Home",
        Key: "Home",
        icon: null,
        url:"/",
        spaName:"derco-mf-home"
    }]
    }